export default __webpack_public_path__ + "static/media/large.07839a04.jpg";